import React from "react";
import styled from "styled-components";
import { FaPassport, FaRedo, FaFileAlt, FaCalendarCheck } from "react-icons/fa";

function About() {
  return (
    <Container>
      <Overlay />
      <Content>
        <Header>About Passport Assistance Services Website</Header>

        <Paragraph>
          Welcome to <strong>Passport Assistance Services</strong>, your trusted
          partner for smooth and reliable passport application support. While we
          are <strong>not affiliated with the Indian Government</strong>, we
          specialize in simplifying the passport process for applicants.
        </Paragraph>

        <Notice>
          <strong>Disclaimer:</strong> This is not an official government
          website. We are a private consultancy service dedicated to
          passport-related guidance.
        </Notice>

        <Paragraph>
          We ensure your application is accurate and complete, reducing chances
          of delays or rejections. Our goal is to guide you through every step —
          from documentation to scheduling appointments.
        </Paragraph>

        <Paragraph>
          <strong>
            This site is built for educational and support purposes only.
          </strong>{" "}
          We aim to make the passport process transparent and stress-free for
          our users.
        </Paragraph>

        <ContactInfo>
          📞 Need help? Contact us at <strong>+91 8788365413</strong> or use the
          contact form. We're here to assist you 6 days a week.
        </ContactInfo>
      </Content>
    </Container>
  );
}

export default About;
const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  padding: 30px 20px;
  background-image: url("/images/passport-bg.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2;
`;

const Content = styled.div`
  position: relative;
  z-index: 3;
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  padding: 60px;
  border: 1px solid #1f1f21;
  color: #f1f1f1;
  padding: 40px;
  border-radius: 15px;
  max-width: 800px;
  width: 100%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  animation: fadeIn 1s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 25px;
  }
`;

const Header = styled.h1`
  font-size: 2rem;
  color: #3f51ff;
  text-align: center;
  border-bottom: 2px solid #3f51ff;
  padding-bottom: 10px;
  margin-bottom: 30px;
  font-family: "Poppins", sans-serif;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Paragraph = styled.p`
  font-size: 1.15rem;
  line-height: 1.8;
  margin-bottom: 20px;
  font-family: "Roboto", sans-serif;

  strong {
    color: #3f51ff;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const Notice = styled.p`
  font-size: 1.1rem;
  color: #ffc107;
  background-color: #333;
  padding: 12px 16px;
  border-left: 4px solid #ff5252;
  margin-bottom: 25px;
  font-family: "Roboto", sans-serif;

  strong {
    color: #ff5252;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ContactInfo = styled.p`
  text-align: center;
  font-size: 1.1rem;
  padding-top: 20px;
  border-top: 1px solid #444;

  strong {
    color: #3f51ff;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;
